const name = ''
const password = ''
const id = ''

export default {
  name,
  password,
  id
}


// WEBPACK FOOTER //
// ./src/global_variable.js